import "./relationshipPopover.scss";

import PropTypes from "prop-types";
import React from "react";

import Icon from "../../components/interface/Icon";
import ListView from "../../components/listView/ListView";
import { PropTypeShapes } from "../../types";

class RelationshipPopoverList extends React.Component {
  constructor(props) {
    super(props);

    this.optionRenderer = this.optionRenderer.bind(this);

    this._dom = null;
  }

  componentDidMount() {
    this._dom ? this._dom.focus() : null;
  }

  optionRenderer(opt, isSelected, ref, index) {
    return (
      <div
        ref={ref}
        className={"relationshipPopoverListItem" + (isSelected ? " highlight" : "")}
        key={index}
        onClick={() => this.props.onClick(opt.id, !opt.selected, opt.inverse)}
      >
        <Icon icon={opt.selected ? "tick" : "blank"} color={opt.color} />
        <div className={`referenceIcon ${opt.icon} ${opt.color}`}>{opt.label.charAt(0)}</div>
        <span>{opt.label}</span>
      </div>
    );
  }

  getListView() {
    const { options, onClick } = this.props;
    const onItemClick = newIndex => {
      const opt = options.find((item, index) => index === newIndex);
      onClick(opt.id, !opt.selected, opt.inverse);
    };

    return (
      <ListView
        className="relationshipPopoverList"
        items={options}
        onItemSelect={onItemClick}
        itemRenderer={this.optionRenderer}
        getDom={dom => (this._dom = dom)}
      />
    );
  }

  render() {
    return this.getListView();
  }
}

RelationshipPopoverList.propTypes = {
  options: PropTypeShapes.popoverListGroup.isRequired,
  onClick: PropTypes.func.isRequired
};

export default RelationshipPopoverList;
